export default {"src":"/_next/static/media/WaterSourceWhite.fa40c54e.svg","height":78,"width":78};